import { Procedure } from '../define-procedure';
import { Store } from '@ngxs/store';
import { MessageEnum } from '../models/message.enum';
import { RPCEvent } from '../define-event';
import { SetInputEnabled } from 'src/app/widget-auth/state/widget.actions';
import { InputIO } from 'src/app/widget-api/models/input.io';

export function getInputEvents(): RPCEvent<InputIO.InputEventResponse>[] {
  return [];
}

export function getInputProcedures(
  store: Store,
): Procedure<InputIO.InputProcRequest, InputIO.InputProcResponse>[] {
  return [
    {
      procName: MessageEnum.InputEnable,
      actionFn: () => {
        store.dispatch(new SetInputEnabled(true));
        return true;
      },
    },
    {
      procName: MessageEnum.InputDisable,
      actionFn: () => {
        store.dispatch(new SetInputEnabled(false));
        return true;
      },
    },
  ];
}
